import { IDeleteAccountEntity, IDeleteAccountDto, IDeleteAccountControls } from "../../profile/interfaces/delete-account.interface";
import { Injectable } from "@angular/core";
import { FormGroup, FormControl } from "@angular/forms";
import { EntityFormModel } from "@app/kernel/form/classes/entity-form-model";
import { IOnFormModelInit } from "@app/kernel/form/interfaces/form-model.interfaces";

@Injectable()
export class DeleteAccountFormModel
  extends EntityFormModel<IDeleteAccountEntity, IDeleteAccountDto, IDeleteAccountControls>
  implements IOnFormModelInit<IDeleteAccountControls>
{
  constructor() {
    super();
  }

  onInit() {
    console.log("init");
  }

  entityToFormValue(entity?: Partial<IDeleteAccountEntity> | null) {
    return { confirmText: entity?.confirmText ?? "" };
  }

  formValueToDtoInput(formValue: IDeleteAccountDto) {
    return { confirmText: formValue.confirmText };
  }

  protected createFormGroup(initialValue: IDeleteAccountDto): FormGroup<IDeleteAccountControls> {
    return new FormGroup<IDeleteAccountControls>({
      confirmText: new FormControl(initialValue.confirmText, {
        nonNullable: true,
      }),
    });
  }
}
